<template>
  <div class="bg-white rounded p-1">
    <div class="mb-2 d-flex aling-items-center gap-10 ml-2">
      <div
        v-for="item in infoCard"
        :key="item.id"
        class="d-flex text-main"
      >
        <div
          class="custom-size"
          :style="{ backgroundColor: item.elipseColor}"
        />
        <div>
          {{ (item.title !== 'Total' && item.title !== 'Total traffic') ? item.title : '' }}
        </div>
      </div>
    </div>
    <div class="d-flex align-items-start justify-content-between flex-wrap bg-white p-1 rounded">
      <apexchart
        class="responsive-chart"
        height="450"
        type="bar"
        :options="computedChartOptions"
        :series="computedSeries"
      />
      <div class="d-flex flex-column align-items-center justify-content-end flex-column custom-direction">
        <info-card
          v-for="item in infoCard"
          :key="item.id"
          :elipse-color="item.elipseColor"
          :title="item.title"
          :description="item.description"
          :loading="item.loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import InfoCard from '@/components/analytics/components/InfoCard.vue'

export default {
  components: {
    apexchart: VueApexCharts,
    InfoCard,
  },
  props: {
    infoCard: {
      type: Array,
      default: () => ([]),
      required: true,
    },
    data: {
      type: [Array, Object],
      default: () => ([]),
    },
    barColors: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  data() {
    return {
      timeStamps: [],
    }
  },
  computed: {
    computedChartOptions() {
      const chartOptions = {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          width: 1,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: this.formattedTimeStamps,
          labels: {
            formatter: value => {
              if (this.computedSeries.length === 0) {
                return 'No Data'
              }
              const unixTimeStamp = parseInt(value, 10)
              return `${this.timeSince(unixTimeStamp, true)} ago`
            },
          },
        },
        noData: {
          text: 'Data Unavailable: Currently, no data is being returned.',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -15,
          style: {
            color: '#7483A1',
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          x: {
            formatter: value => `${this.unixTimestampToDateTime(value)}`,
          },
          y: {
            formatter: value => `${value} request${value === 1 ? '' : 's'}`,
          },
        },

        fill: {
          opacity: 1,
        },
        colors: this.barColors,
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          show: false,
        },
      }
      return chartOptions
    },
    formattedTimeStamps() {
      if (!this.computedSeries || !this.computedSeries[0] || !this.computedSeries[0].timeStamps) {
        return []
      }
      return this.computedSeries[0].timeStamps.map(timestamp => parseInt(timestamp, 10)) || []
    },
    computedSeries() {
      const series = this.data?.result?.map(entry => ({
        name: entry.name[0].toUpperCase() + entry.name.slice(1),
        data: entry.data?.map(dataEntry => dataEntry?.value),
        timeStamps: entry.data?.map(dataEntry => dataEntry?.timestamp),

      }))
      return series
    },
  },
}
</script>
<style scoped>

 .responsive-chart {
   width: 90%; /* Chart will take 100% width on all screen sizes */
 }

 .custom-size {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  margin-top: 6px;
  margin-right: 5px;
}

.gap-10{
  gap:10px
}

 @media (min-width: 220px) {
  .responsive-chart {
      width: 100%; /* Adjust the height for larger screens (e.g., tablets) */
   }
   .custom-direction{
    flex-direction: row !important;
    justify-content: start !important;
    flex-wrap: wrap;
    gap: 4px;
   }

   .custom-margin{
    margin-top: 0px !important;
    margin-right: 3px !important;
   }

 }

 @media (min-width: 992px) {
   .responsive-chart {
      width: 70%; /* Adjust the height for larger screens (e.g., tablets) */
   }

   .custom-margin {
    margin-top: 5px !important;
   }
   .custom-direction{
    flex-direction: column !important;
   }

 }

 @media (min-width: 1200px) {
   .responsive-chart {
    width: 75%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }

 @media (min-width: 1600px) {
   .responsive-chart {
    width: 82%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }
</style>
